
export const defaultBuildingProcess = {
    wallPIP: {
        name: "Voile coulé en place",
        unitOfMeasure: "m",
        measure: 2,
        totalMinute: 600,
        steps: [{
            name: "Préparation",
            description: "Préparer la zone de travail (implantation...)",
            workerCount: 2,
            workerMinute: 60,
            craneMinute: 0
        },
        {
            name: "Pose 1er coffrage",
            description: "Elinguer et lever la 1ère peau de coffrage, Poser la 1ère peau de coffrage, Stabiliser la 1ère peau de coffrage, Désélinguer la 1ère peau de coffrage",
            workerCount: 2,
            workerMinute: 120,
            craneMinute: 10

        },
        {
            name: "Installation",
            description: "Pré-régler l'aplomb et aligner la 1ère peau de coffrage, Préparer la 1ère peau de coffrage (abouts, reservations...)",
            workerCount: 2,
            workerMinute: 120,
            craneMinute: 0
        },
        {
            name: "Ferraillage",
            description: "Férrailler le voile avant fermeture",
            workerCount: 2,
            workerMinute: 120,
            craneMinute: 10
        },
        {
            name: "Pose 2ème coffrage",
            description: "Elinguer et lever la 2eme peau de coffrage, Poser la 2ème peau de coffrage, Stabiliser la 2ème peau de coffrage, Désélinguer la 2ème peau de coffrage, Fermer le coffrage",
            workerCount: 2,
            workerMinute: 120,
            craneMinute: 10

        },
        {
            name: "Coulage",
            description: "Bétonner le voile",
            workerCount: 2,
            workerMinute: 120,
            craneMinute: 10
        }]
    }
}